import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/surveys/$surveyId/topics")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
